<script lang="ts">
  import WhatsApp from "~icons/ph/whatsapp-logo-fill";

  let {
    model,
    existingSmsOptIn,
    existingWhatsAppOptIn,
    collapseWhatsAppMessage = false,
    selectOptIn = false,
  }: {
    model: string;
    existingSmsOptIn: boolean;
    existingWhatsAppOptIn: boolean;
    collapseWhatsAppMessage: boolean;
    selectOptIn: boolean;
  } = $props();

  let smsOptIn = $state(existingSmsOptIn?.toString());
  let whatsAppOptIn = $state(existingWhatsAppOptIn?.toString());

  if (selectOptIn) {
    smsOptIn = "true";
    whatsAppOptIn = "true";
  }
</script>

<div class="flex flex-col">
  <div class="grid-container max-w-md mb-[--ui-gap]">
    <div>Email (required)</div>
    <label class="bg-yellow-100 rounded-t">
      <input type="radio" class="radio" checked required />
      <span>Yes</span>
    </label>
    <label>
      <input type="radio" class="radio !opacity-100" disabled />
      <span>No</span>
    </label>

    <hr class="col-span-3 border-t-0 border-b-2" />

    <div>WhatsApp</div>
    <label class="bg-yellow-100">
      <input
        type="radio"
        class="radio bg-white"
        name="{model}[whatsapp_opt_in]"
        value="true"
        bind:group={whatsAppOptIn}
        required
      />
      <span>Yes</span>
    </label>
    <label>
      <input
        type="radio"
        class="radio"
        name="{model}[whatsapp_opt_in]"
        value="false"
        bind:group={whatsAppOptIn}
      />
      <span>No</span>
    </label>

    <div>Text message</div>
    <label class="bg-yellow-100 rounded-b">
      <input
        type="radio"
        class="radio bg-white"
        name="{model}[sms_opt_in]"
        value="true"
        bind:group={smsOptIn}
        required
      />
      <span>Yes</span>
    </label>
    <label>
      <input
        type="radio"
        class="radio"
        name="{model}[sms_opt_in]"
        value="false"
        bind:group={smsOptIn}
      />
      <span>No</span>
    </label>
  </div>

  <p class="text-gray-600 text-sm">
    By opting in, you agree to receive SMS messages from Johnson Law Group.
    Standard rates may apply.
  </p>

  <div class={[
    "ui-alert ui-alert-info",
    whatsAppOptIn !== "true" && (collapseWhatsAppMessage ? "hidden" : "invisible")
  ]}>
    <WhatsApp />
    <p>
      WhatsApp coming soon!
      <br class="sm:hidden">
      <strong class:hidden={smsOptIn !== "false"}>May we text you in the meantime?</strong>
      <strong class:hidden={smsOptIn !== "true"}>We will text you in the meantime.</strong>
    </p>
  </div>
</div>

<style lang="postcss">
  .grid-container {
    @apply grid items-center;
    grid-template-columns: 1fr auto auto;
  }

  label {
    @apply cursor-pointer p-2 flex gap-2 items-center;

    & > span {
      @apply label-text;
    }
  }
</style>
